import { http } from "./http.js";

async function getAddress(resource, id) {
  const response = await http.get(`${resource}/${id === "0" ? "new" : id}`);
  return {
    id: response.data.Id,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
      inputLanguage: response.data.Country.InputLanguage,
    },
    district: response.data.District
      ? {
        id: response.data.District.Id,
        title: response.data.District.Title,
        isRemoved: response.data.District.IsRemoved,
      }
      : null,
    region: {
      id: response.data.Region.Id,
      title: response.data.Region.Title,
      isRemoved: response.data.Region.IsRemoved,
    },
    city: {
      id: response.data.City.Id,
      title: response.data.City.Title,
      isRemoved: response.data.City.IsRemoved,
    },
    street: response.data.Street,
    buildNumber: response.data.BuildNumber,
    postcode: response.data.Postcode,
    isRemoved: response.data.IsRemoved,
    isConfirmed: response.data.IsConfirmed,
  };
}

async function getAddressReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    country: {
      id: response.data.Country.Id,
      title: response.data.Country.Title,
    },
  };
}

async function getQueryReference(resource, queryParams) {
  const response = await http.get(`${resource}/referencies?${queryParams}`);
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response.data;
  }
}

async function updateAddress(resource, id, entity) {
  const response = await http.put(`${resource}/${id}`, entity);
  return response;
}

async function createAddress(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function changeRemovedState(resource, entity) {
  const response = await http.patch(
    `/${resource}/${entity.id}/rpc/change-removed-state`,
    {
      value: !entity.isRemoved,
    },
  );
  return response;
}

async function deleteAddress(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return response;
}

async function selectIndex(filter) {
  const response = await http.get(`locations/search?${filter}`);
  return response.data.map(i => {
    return {
      id: i.Id,
      code: i.Code,
      country: {
        id: i.Country.Id,
        isRemoved: i.Country.IsRemoved,
        title: i.Country.Title,
      },
      district: i.District ? {
        id: i.District.Id,
        isRemoved: i.District.IsRemoved,
        title: i.District.Title,
      } : null,
      region: {
        id: i.Region.Id,
        isRemoved: i.Region.IsRemoved,
        title: i.Region.Title,
      },
      city: {
        id: i.City.Id,
        isRemoved: i.City.IsRemoved,
        title: i.City.Title,
      },
      fullTitle: `${i.Code}*${i.Country.Title}*${i.Region.Title}*${i.City.Title}`,
    };
  });
}

export {
  getAddress,
  getAddressReference,
  getQueryReference,
  updateAddress,
  createAddress,
  changeRemovedState,
  deleteAddress,
  selectIndex,
};
